/**
 * ADR (Average Daily Rate) Trend Chart (Highcharts)
 * Spline chart showing ADR over time
 */
import { useMemo } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

export default function ADRTrendChart({ data = [] }) {
  const options = useMemo(() => {
    if (!data || data.length === 0) {
      return {
        title: { text: 'Average Daily Rate Trend' },
        subtitle: { text: 'No data available for this period/channel' },
        series: [],
      };
    }

    return {
      chart: {
        type: 'spline',
        height: 350,
      },
      title: {
        text: 'Average Daily Rate Trend',
        style: { fontSize: '16px', fontWeight: '600' },
      },
      xAxis: {
        categories: data.map(d => d.month),
        title: { text: 'Month' },
      },
      yAxis: {
        title: { text: 'ADR ($)' },
        labels: {
          formatter: function() {
            return '$' + this.value.toFixed(0);
          },
        },
      },
      tooltip: {
        backgroundColor: '#ffffff', // Fully opaque white background
        borderColor: '#e5e7eb',
        borderWidth: 1,
        style: {
          color: '#111827', // Dark text for readability
        },
        formatter: function() {
          return '<b>' + this.x + '</b><br/>' +
            'ADR: <b>$' + this.y.toFixed(2) + '</b><br/>' +
            'Total Revenue: $' + Highcharts.numberFormat(this.point.total_revenue || 0, 0) + '<br/>' +
            'Total Nights: ' + (this.point.total_nights || 0);
        },
      },
      plotOptions: {
        spline: {
          dataLabels: {
            enabled: true,
            formatter: function() {
              // Only show labels for values > $50 to avoid clutter
              if (this.y > 50) {
                return '$' + this.y.toFixed(0);
              }
              return '';
            },
            style: {
              fontSize: '11px',
              fontWeight: '500',
              textOutline: '1px contrast',
            },
          },
        },
      },
      series: [{
        name: 'ADR',
        data: data.map(d => ({
          y: d.adr,
          total_revenue: d.total_revenue,
          total_nights: d.total_nights,
        })),
        color: '#50C878',
        lineWidth: 3,
        marker: { radius: 5 },
      }],
      credits: { enabled: false },
    };
  }, [data]);

  return <HighchartsReact highcharts={Highcharts} options={options} />;
}
